import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import "../AccountingLedger/accounting.css";
import AcctTable from "./components/AcctTable";

const CreditFacility = () => {
    const navigate = useNavigate(); 

    return (
        <RouteLayout title={"Finance"}>
            <div className="p-5">
                <div className="flex justify-between">
                    <p className="text-3xl font-medium text-[#305F32]">
                        Credit Facility
                    </p>
 
                </div>

                <div className="bg-[#FFFFFF] rounded-sm mt-5 p-5">
                    <AcctTable />
                </div>
            </div>
        </RouteLayout>
    );
};

export default CreditFacility;
